import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import AdvisoryPriceDisplay from '@stubhub/react-advisory-price-display';

// CSS
import './index.scss';

/**
 * @param currency
 * @param amount
 */
const Price = ({currency, amount, className = ''}) => {
  return (
    <div className={`PriceDisplay ${className}`}>
      <div className="PriceDisplay__price">
        <AdvisoryPriceDisplay price={amount} currency={currency} />
      </div>
      <div className="PriceDisplay__each">
        <FormattedMessage id="TicketList.price.each" defaultMessage="each" />
      </div>
    </div>
  );
};

Price.propTypes = {
  currency: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,

  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,
};

export default Price;
